<template>
  <div class="absoulte top-0 w-full max-w-xl">
    <div class="absolute top-20 left-0 w-72 h-72 bg-indigo-600 rounded-full mix-blend-multiply filter blur-2xl opacity-20 animate-blob"></div>
    <div class="absolute top-40 left-56 w-72 h-72 bg-violet-600 rounded-full mix-blend-multiply filter blur-2xl opacity-20 animate-blob"></div>
    <div class="absolute top-60 right-40 w-36 h-36 bg-sky-600 rounded-full mix-blend-multiply filter blur-2xl opacity-20 animate-blob"></div>
    <div class="absolute top-128 right-1/2 w-96 h-96 bg-violet-600 rounded-full mix-blend-multiply filter blur-2xl opacity-20 animate-blob"></div>
  </div>
</template>

<script>
export default {
  name: 'Blobs'
}
</script>